import { createBrowserRouter, Navigate, redirect, RouterProvider } from 'react-router-dom'
import { RenderTopMenuChildComponentProvider } from '@/providers/TopMenuChildrenProvider'

import Home from '@/app/Home'
import Processes from '@/app/processes'
import HistoricProcesses from '@/app/historic-processes'
import LayoutPage from '@/app/layout'
import GraphLab from '@/app/graph-lab'

const Router = () => {
  const router = createBrowserRouter([
    {
      children: [
        {
          index: true,
          loader: () => redirect('/procesamientos'),
        },
        {
          element: <Home />,
          path: '/home',
        },
        {
          element: <Processes mode="create" />,
          path: '/procesamientos/crear',
        },
        {
          element: <Processes mode="edit" />,
          path: '/procesamientos/editar',
        },
        {
          element: <Processes mode="view" />,
          path: '/procesamientos/ver',
        },
        {
          element: <HistoricProcesses />,
          path: '/procesamientos',
        },
        {
          element: <GraphLab />,
          path: '/graph',
        },
        {
          element: <Navigate replace to={`/${window.location.search}`} />,
          path: '*',
        },
      ],
      element: <LayoutPage />,
      path: '/',
    },
  ])
  return <RouterProvider router={router} />
}

export default Router
